/**
 * 钱包特殊跳转
 */
import useragent from '@common/useragent'
import domain from '@common/domain'
import { compare } from './version'
import closeView from './closeView'
import requestUpdateWallet from './requestUpdateWallet'
import { call, uriSuishouji } from './bridge'

export default () => {
  if (useragent.isSuishouji) {
    const featureVersion = useragent.isAndroid ? '10.2.5.0' : '10.4.6'
    if (compare(featureVersion)) {
      call(uriSuishouji('requestWalletBackToProductList'))
    } else {
      requestUpdateWallet()
      closeView()
    }
  } else {
    window.location.href = `${domain.res}/public-vue/product/index.html#/wallet`
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/requestWalletBackToProductList.js